import React from 'react';
import { Dropdown } from 'react-bootstrap';
import {
  ContentCopy,
  EditOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { copyOfferLink } from '../utils';
import { JdsMoreToggle } from '../../../components/jds/JdsMoreToggle';
import { jdsMenuPopperConfig } from '../../../components/jds/popper';

export function OfferRowActions({ offer }) {
  const history = useHistory();

  const detailsHref = `/payments/offers/${offer.id}`;
  const editHref = `/payments/offers/${offer.id}/edit`;

  const navigate = (href) => (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    history.push(href);
  };

  return (
    <Dropdown alignRight>
      <Dropdown.Toggle
        as={JdsMoreToggle}
        variant="ghost"
        size="sm"
        id={`offer-actions-${offer.id}`}
        aria-label="Abrir opções da oferta"
      />
      <Dropdown.Menu
        className="dropdown-menu-sm"
        popperConfig={jdsMenuPopperConfig}
      >
        <Dropdown.Item
          onClick={() => copyOfferLink(offer)}
          style={{ whiteSpace: 'normal' }}
        >
          <ContentCopy style={{ fontSize: 18, marginRight: 8 }} />
          Copiar link
        </Dropdown.Item>
        <Dropdown.Item
          href={detailsHref}
          onClick={navigate(detailsHref)}
          style={{ whiteSpace: 'normal' }}
        >
          <VisibilityOutlined style={{ fontSize: 18, marginRight: 8 }} />
          Visualizar oferta
        </Dropdown.Item>
        <Dropdown.Item
          href={editHref}
          onClick={navigate(editHref)}
          style={{ whiteSpace: 'normal' }}
        >
          <EditOutlined style={{ fontSize: 18, marginRight: 8 }} />
          Editar oferta
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
